export enum RadiusUnits {
  miles = 'miles',
  kilometers = 'kilometers',
}
export type RadiusUnit = keyof typeof RadiusUnits;
export type Radius = {
  value: number;
  unit: RadiusUnit;
  displayFormat: string;
  display: string;
};
